import React, { useEffect, useState } from "react";
import axios from "axios";
import { dashboardURL } from "../../Config/Url";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import Card from "react-bootstrap/Card";
import SpinnerLoading from "../Common/SpinnerLoading";

const LastActivatedPos = () => {
  const [lastActivatedPos, setLastActivatedPos] = useState([]);
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);

  let config = {
    headers: {
      "X-IsMockup": false,
    },
  };

  useEffect(() => {
    axios
      .get(`${dashboardURL}/last-activated-pos`, config)
      .then((result) => {
        setLastActivatedPos({
          description: result.data.description,
          activationDate: format(
            new Date(result.data.activationDate),
            "dd. MM. yyyy."
          ),
          serialNumber: result.data.serialNumber,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        setLastActivatedPos({
          description: translator("No-Data"),
          activationDate: "",
          serialNumber: "",
        });
        setIsLoading(false);
      });
  }, []);

  return (
    <>
      {isLoading && (
        <div className="dashboard-card-spinner">
          <SpinnerLoading />
        </div>
      )}

      {!isLoading && (
        <>
          <Card.Body className="dashboard-card-body-pos">
            <div className="dashboard-card-body-pos-part1">
              <span
                className="icon icon-cash-register"
                style={{ fontSize: 85 }}
              ></span>
              <div className="dashboard-card-body-pos-complexData">
                <span className="dashboard-card-body-pos-data-description">
                  {lastActivatedPos.description.length >= 20
                    ? `${lastActivatedPos.description.substring(0, 20)}...`
                    : lastActivatedPos.description}
                </span>
                <span className="dashboard-card-body-pos-data-sn">
                  SN: {lastActivatedPos.serialNumber}
                </span>
              </div>
            </div>
            <div className="dashboard-card-body-pos-part2">
              {lastActivatedPos.activationDate}
            </div>
          </Card.Body>
          <Card.Footer className="dashboard-card-footer-pos">
            {translator("Dashboard-LastActivatedPos-Title")}
          </Card.Footer>
        </>
      )}
    </>
  );
};

export default LastActivatedPos;
